module.exports = __webpack_public_path__ + "img/lore_frame.6af651ea.png";